'use client'

import Link from 'next/link'
import { Icons } from '@/components/icons'
import { cn } from '@/lib/utils'

export function MainNav() {
  return (
    <div className="mr-4 hidden lg:flex">
      <Link href="/" className="mr-6 flex items-center space-x-2">
        <Icons.logo className="h-14 w-14" />
        <span className="hidden font-bold sm:inline-block">347 Facts</span>
      </Link>
      <nav className="flex items-center space-x-6 text-sm font-medium" aria-label="Global">
        <Link
          href="/#currently-funded"
          className={cn('hover:text-foreground/80 transition-colors')}
        >
          Currently Funded/Completed Items
        </Link>
        <Link href="/#faqs" className={cn('hover:text-foreground/80 transition-colors')}>
          FAQs
        </Link>
        <Link href="/donate" className={cn('hover:text-foreground/80 transition-colors')}>
          Donate
        </Link>
      </nav>
    </div>
  )
}
